export default (prev, next) => ({ ...prev, ...next });
